// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hXskAuaXBn38yV {
  display: flex;
  align-items: center;
  justify-content: left;
  padding: 20px var(--ds-space-0, 0);
}
.HKcmSms8JPHKYa {
  position: relative;
  margin-right: var(--ds-space-200, 16px);
}
.AL7VhEa5mXkRAx {
  display: flex;
  flex-direction: column;
  align-items: baseline;
}
.AL7VhEa5mXkRAx .x963c8RWsP5scD {
  margin-right: var(--ds-space-150, 10px);
  margin-bottom: var(--ds-space-0, 0);
  color: var(--ds-text, #172b4d);
  font-size: 20px;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 24px;
}
.AL7VhEa5mXkRAx .HBzvDiBUG7b07T {
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 20px;
}
`, ""]);
// Exports
export var homeHeader = `hXskAuaXBn38yV`;
export var avatar = `HKcmSms8JPHKYa`;
export var details = `AL7VhEa5mXkRAx`;
export var name = `x963c8RWsP5scD`;
export var username = `HBzvDiBUG7b07T`;
export default ___CSS_LOADER_EXPORT___;
